"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ArrowLeft = function ArrowLeft(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.268 19.598a.653.653 0 0 1-.402.134.483.483 0 0 1-.357-.134l-9.33-9.375A.424.424 0 0 1 0 9.866c0-.149.06-.268.179-.357L9.509.134A.483.483 0 0 1 9.866 0c.149 0 .283.045.402.134l.893.893c.089.09.134.208.134.357a.653.653 0 0 1-.134.402l-6.92 6.92h15.223c.15 0 .276.051.38.156.104.104.156.23.156.38v1.25a.517.517 0 0 1-.156.379.517.517 0 0 1-.38.156H4.241l6.92 6.92c.089.118.134.252.134.401a.483.483 0 0 1-.134.357l-.893.893z",
    id: "arrowLeft"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#arrowLeft"
  }));
};

var _default = ArrowLeft;
exports["default"] = _default;
module.exports = exports["default"];